export default __webpack_public_path__ + "static/media/Dead (5).83df1569.png";